import React, { useEffect, useState } from 'react';
import { useRouteError } from 'react-router-dom';
import { isChunkLoadError, reloadForNewVersion } from '../utils/chunkReload';

export default function RouteError() {
  const error = useRouteError();
  const [needsTap, setNeedsTap] = useState(false);
  const chunkError = isChunkLoadError(error);

  useEffect(() => {
    if (chunkError && !reloadForNewVersion()) {
      setNeedsTap(true);
    }
  }, [chunkError]);

  return (
    <div style={{ fontFamily: 'sans-serif', padding: 24, maxWidth: 480, margin: '10vh auto' }}>
      <h1 style={{ color: '#2e7d32' }}>NaeWaste needs a refresh</h1>
      <p>
        {chunkError
          ? 'The app was updated. Reload the page to continue.'
          : 'Something went wrong. Reload the page and try again.'}
      </p>
      {(needsTap || !chunkError) && (
        <button
          type="button"
          onClick={() => window.location.reload()}
          style={{ background: '#2e7d32', color: 'white', border: 0, borderRadius: 8, padding: '12px 16px' }}
        >
          Reload
        </button>
      )}
    </div>
  );
}
